export class Insurance {
  insurance_id?: number;
  dt?: string;
  firstname?: string;
  user_id?: number;
  patient_id?: number;
  version_status?: number;
  insurance_number?: string;
  insurance_name?: string;
  version_id?: number;
  status?: number;
  lastname?: string;
  [key: string]: any;
}
